import React, {useContext, useEffect, useState} from 'react';
import {LogsContext} from "../../logsContext";
import {useHistory} from "react-router-dom";
import {WMSRoutes} from "../../../../../utils/WMSRoutes";
import {WMSOmniScanReturnType} from "../../../../../utils/WMSOmniScanReturnType";
import {WMSContext} from "../../../context/WMSContext";
import {getLogs} from "../../../../../api/wms/logs/list";
import LogWmsItem from "./component/LogWmsItem";
import LogShipmentItem from "./component/LogShipmentItem";
import LogContainerItem from "./component/LogContainerItem";

function ItemLogSearch() {
    const {currentInventory} = useContext(WMSContext);
    const {itemId, itemType} = useContext(LogsContext);

    const [itemList, setItemList] = useState([]);

    const history = useHistory()

    useEffect(() => {
        if (!itemId.current) {
            return null
        }

        getLogs(itemId.current, currentInventory.id).then((response) => {
            setItemList(response)
        })
    }, []);

    if (!itemId.current) {
        history.push(`${WMSRoutes.LOGS}`)
    }
    return (
        <>
            {itemList.map((item) => (
                <>
                    {WMSOmniScanReturnType.ITEM === itemType.current && 0 < itemList.length  && (
                        <LogWmsItem item={item}/>
                    )}

                    {WMSOmniScanReturnType.SHIPMENT === itemType.current && 0 < itemList.length  && (
                        <LogShipmentItem item={item}/>
                    )}

                    {WMSOmniScanReturnType.CONTAINER === itemType.current && 0 < itemList.length  && (
                        <LogContainerItem item={item}/>
                    )}
                </>
            ))}
        </>
    );
}

export default ItemLogSearch;